import SearchViewSwitch from './SearchViewSwitch'

export default SearchViewSwitch
